import { Tab } from '@shared/components/page-tabs';
import { generatePath } from 'react-router-dom';
import { soldGoodsRoutes } from '../sold-goods-routes';
import { useSoldPackagingItem } from './sold-packaging-item-context';

export function useSoldPackagingTabs(): Tab[] {
  return [
    {
      title: 'Items',
      href: soldGoodsRoutes.SOLD_PACKAGING,
    },
    {
      title: 'Data coverage',
      href: soldGoodsRoutes.SOLD_PACKAGING_DATA_COVERAGE,
    },
  ];
}

export function useSoldPackagingItemsTabs(): Tab[] {
  const { item, referrer } = useSoldPackagingItem();
  const company_reports = referrer?.startsWith('/company-reports/')
    ? [referrer.split('/')[2]]
    : undefined;
  return [
    {
      title: 'Item',
      href: generatePath(soldGoodsRoutes.SOLD_PACKAGING_ITEM, {
        item_uuid: item?.uuid || ':item_uuid',
      }),
    },
    // {
    //   title: 'Emissions',
    //   disabled: true,
    //   href: generatePath(soldGoodsRoutes.SOLD_PACKAGING_ITEM_EMISSIONS, {
    //     item_uuid: item?.uuid || ':item_uuid',
    //   }),
    // },
    {
      title: 'Sales',
      href: generatePath(
        soldGoodsRoutes.SOLD_PACKAGING_ITEM_SALES +
          ((company_reports &&
            `?companyReport=${company_reports?.join(',')}`) ||
            ''),
        {
          item_uuid: item?.uuid || ':item_uuid',
        }
      ),
    },
  ];
}
